import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "report-templates",
  courseId: "your-style",
  order: 2,
  title: "Report templates",
  subtitle: "And placeholders",
  summary:
    "A template is a header, writing instructions, and a footer that the AI applies to a draft. Build one per report type, such as DUI, and set a default.",
  learn: [
    "Create a template with a header, instructions, and footer",
    "Insert placeholders the AI fills or leaves for you",
    "Pick a template per case and set a default",
  ],
  sceneId: "report-templates",
  tourId: "report-templates",
  minutes: 5,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "Templates live on the Report Preferences page. Each has three parts: Custom Header (boilerplate at the top), Narrative Writing Instructions (how to structure the body), and Custom Footer. Department templates show a \"Dept\" badge and are read-only, but you can still choose them.",
    },
    {
      type: "steps",
      items: [
        "Open **Report Preferences** and scroll to Report templates.",
        "Click **New Template** and name it (for example \"DUI\").",
        "In Custom Header, type anything that opens every report of this type. Click **Insert AI Placeholder / Instruction** to add placeholders like {{Case Number}}, which become bracketed fields in the draft.",
        "In Narrative Writing Instructions, tell the AI how to structure the body: sections to include, order, and what to emphasize.",
        "In Custom Footer, add the closing block, then save.",
        "Click **Save Preferences**, then open the template's gear menu and choose **Set as default** so it is pre-selected in **Report Settings** on every upload.",
        "On a new case, open **Report Settings** and choose the template from **Report Template**, or choose \"No template (only use preferences)\".",
      ],
    },
    {
      type: "paragraph",
      text: "The template list also has **Rename**, **Duplicate**, and Delete. Writing instructions in a template replace the additional-instructions preference for cases that use it.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Put facts the AI cannot know (case number, CAD event) in header placeholders, and put structure in the instructions. Do not put facts in the instructions. Put them in your dictation.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What a template overrides",
      text: "A template replaces your header, footer, and writing-instructions preferences for that case. Everything else (perspective, time format, rank, call sign) still comes from Report Preferences.",
    },
    {
      type: "callout",
      tone: "warning",
      title: "The template is fixed at creation",
      text: "The template on a case is set when the case is created. To try a different template on the same audio, start a new case from **Previous Uploads**.",
    },
  ],
  related: ["report-preferences-in-depth", "regenerate-the-narrative", "department-preferences-templates-checklists"],
};

export default lesson;
